import Logo from "../assets/Logo.png";
import PostImage from "../assets/posts/post1.jpg"
import PostProfileImage from "../assets/posts/post-profile.svg"
import HeroImage from "../assets/HeroImage.png"

// Square Icons
import FacebookSquareIcon from "../assets/social_icons/facebook-square-icon.png";
import InstagramSquareIcon from "../assets/social_icons/instagram-square-icon.svg";
import XSquareIcon from "../assets/social_icons/x-square-icon.png";
import RedditSquareIcon from "../assets/social_icons/reddit-square-icon.png";
import TiktokSquareIcon from "../assets/social_icons/tiktok-icon.svg";
import WhatsappSquareIcon from "../assets/social_icons/whatsapp-icon.svg";
import XIcon from "../assets/social_icons/x-icon.svg";

// LoadingImage
import LoadImage1 from "../assets/load_image1.png";
import LoadImage2 from "../assets/load_image2.png";
import LoadImage3 from "../assets/load_image3.png";
import LoadImage4 from "../assets/load_image4.png";
import LoadImage5 from "../assets/load_image5.png";

const images = {
    Logo,
    PostImage,
    HeroImage,
    PostProfileImage,
    TiktokSquareIcon,    
    InstagramSquareIcon,
    FacebookSquareIcon,
    WhatsappSquareIcon,
    XIcon,
    XSquareIcon, 
    RedditSquareIcon
};

export function getLoadingImage(image_id) {

    switch(image_id) {
        case "1":
            return LoadImage1;
        case "2":
            return LoadImage2;
        case "3":
            return LoadImage3;
        case "4":
            return LoadImage4;
        case "5":
            return LoadImage5;
        default:
            return LoadImage3;
      }
}

export default images;

